import Input from "@mui/material/Input";
import styled from "@mui/material/styles/styled";

import { lightOrDark } from "@app/embedded/theme/utils";

import { Column, Row } from "@rui/Stack";

export const Wrapper = styled(Column)({
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  zIndex: 10,
});

export const SearchBoxWrapper = styled(Column)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.transparent.black[12]}`,
  boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
  "&:focus-within": {
    borderColor: theme.palette.shades.primary[500],
  },
}));

export const FindAndReplaceWrapper = styled(Row)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
  height: "48px",
  borderTop: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
}));

export const FindAndReplaceInput = styled(Input)(({ theme }) => ({
  flexGrow: 1,
  fontSize: "0.875rem",
  "&::placeholder": {
    color: lightOrDark(
      theme.palette.shades.neutral[400],
      theme.palette.shades.neutral[100]
    )(theme),
  },
  "& .MuiSvgIcon-root": {
    marginRight: theme.spacing(1),
    color: theme.palette.shades.neutral[400],
    fontSize: "18px",
  },
}));
